import { apiClient } from '../utils/api-client';

/**
 * Consent context returned by GET /oauth/authorize/context - the validated OAuth
 * request plus a one-time consent token bound to the logged-in staff user.
 */
export type AgentConsentContext = {
  readonly client_id: string;
  readonly scope: string;
  readonly redirect_uri: string;
  readonly code_challenge: string;
  readonly code_challenge_method: string;
  readonly state: string | null;
  readonly authorizing_user_email: string;
  readonly consent_token: string;
};

/** OAuth authorize params forwarded from the SPA consent route's query string. */
export type AgentConsentParams = {
  readonly response_type: string;
  readonly client_id: string;
  readonly redirect_uri: string;
  readonly code_challenge: string;
  readonly code_challenge_method: string;
  readonly scope?: string;
  readonly state?: string;
};

export const agentAuthService = {
  async getConsentContext(
    params: AgentConsentParams
  ): Promise<AgentConsentContext> {
    return apiClient.get<AgentConsentContext>('/oauth/authorize/context', {
      params,
    });
  },
};
